import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type {
  FileUploadsAttribute,
  FileUploadsResponse,
} from 'types/fileUploads';
import { useWorkspaceContext } from './common/useWorkspaceContext';

type MutationVariables = Partial<FileUploadsAttribute>;
export function useFileUploads() {
  const queryClient = useQueryClient();
  const { currentWorkspaceID } = useWorkspaceContext();
  const uploadFiles = (fileUploadsAttributes: MutationVariables) => {
    const body = {
      data: {
        type: 'fileUploads',
        attributes: {
          ...fileUploadsAttributes,
          uploadType: fileUploadsAttributes.uploadType || 'file',
          workspaceID: currentWorkspaceID,
        },
      },
    };
    return fetchWrapper<FileUploadsResponse>({
      url: `fileUploads`,
      method: 'POST',
      body,
    });
  };

  return useMutation('uploadFiles', uploadFiles, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to upload Files: ${error.message}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('memory');
    },
  });
}
